// extracted by mini-css-extract-plugin
export var chevronIcon = "_d3-2";
export var teamName = "_d3-1";
export var teamSwitcherButton = "_d3-0";